import React, { useContext, useState } from "react";

const LayoutContext = React.createContext({
  isSidebarClosed: false,
  toggleSidebar: () => {},
});

const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSidebarClosed, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarClosed);
  };

  return (
    <LayoutContext.Provider value={{ isSidebarClosed, toggleSidebar }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  return useContext(LayoutContext);
};

export default LayoutProvider;
